import axios from "./axios";
import { api } from "./axios.config";

const AUTH_API = api.authApiUrl;
const API_URL = api.apiUrl;
const API_MANAGE_URL = api.manageApiUrl;

const USERS = "/user";
const USERS_AUTH = "/auth/user";

export function getUserById() {
	return axios.get(API_URL + USERS + "/");
}

export const subscribeUser = (emailId, clientType, subscriptionSource) => {
	const data = { email_id: emailId };
	return axios.post(AUTH_API + "/subscribe", data, {
		headers: { "client-type": clientType, "subscription-source": subscriptionSource }
	});
};